//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ObjectType",1,0],[1,"Objects",0,"SelectNXObjectList",0],[0,"Part",1,"Part",0],[0,"PartForKF",0,"Part",0]],[[[],"ResetListToGlobal",{},0,0],[["inputObject"],"InitializeListFromObject",{},1,0],[[],"ClearSecondaryComponentList",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.DraftingComponentSelectionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DraftingComponentSelectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DraftingComponentSelectionBuilder.Geometry = Object.freeze({
    "PrimaryGeometry" : "PrimaryGeometry", "SecondaryGeometry" : "SecondaryGeometry"});

export default SPLM;